<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="computedSize"
        :height="computedSize"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="color || 'currentColor'"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="blog-icon">
        <!-- 文档/博客：带文字行的文件 + 笔 -->
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="8" y1="13" x2="16" y2="13" />
        <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { pxToRem } from '@/utils/rem/rem';

const props = withDefaults(
    defineProps<{
        size?: number | string;
        color?: string;
    }>(),
    {
        size: 20,
        color: ''
    }
);

const computedSize = computed(() => {
    return pxToRem(props.size);
});
</script>

<style scoped>
.blog-icon {
    display: inline-block;
    vertical-align: middle;
}
</style>
